// const SCRIPT_ID = "cart-script";
// const SCRIPT_SRC = "https://multi-oxygenetic.trecnutrition.com/extshop/getscript/OXLE325T.js";

/**
 * Called when the user changes routes, including the initial load.
 * We use this to ensure the external cart script is loaded and
 * potentially re-executed after client-side navigation.
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  const doc = document.querySelector('main');
  doc && doc.classList.add('is-loaded');
  console.log("Route updated to:", location.pathname);

  // if (prevLocation) {
  //   console.log("Route updated via client-side navigation to:", location.pathname);

  //   // 1. Find any existing script tag added by previous navigations or SSR
  //   const existingScript = document.getElementById(SCRIPT_ID);

  //   // 2. Remove the existing script tag if it exists.
  //   if (existingScript) {
  //     console.log("Removing existing cart script tag:", SCRIPT_ID);
  //     existingScript.remove();
  //   } else {
  //     console.log("No existing cart script tag found with ID:", SCRIPT_ID);
  //     // This might happen if SSR failed or the ID is different.
  //     // Still proceed to add the new script.
  //   }

  //   // 3. Create a new script tag
  //   const script = document.createElement("script");
  //   script.id = SCRIPT_ID; // Assign the ID for future lookups
  //   script.src = SCRIPT_SRC;
  //   // Add type="text/javascript" if necessary, though often optional
  //   script.type = "text/javascript";
  //   // Ensure it runs after parsing, similar to default script tag behavior
  //   // 'async' or 'defer' could change execution timing, use with caution
  //   // script.async = true; // Might cause issues if script depends on DOM ready
  //   // script.defer = true; // Might be okay, depends on the script

  //   script.onload = () => {
  //     console.log("Newly added cart script loaded:", SCRIPT_SRC);
  //     // Now, the script should have executed, and WhisperRemoteInstance *might*
  //     // be available *if* its initialization is synchronous within the script.
  //     // However, we don't rely on accessing it directly with this method.
  //   };
  //   script.onerror = () => {
  //     console.error("Error loading newly added cart script:", SCRIPT_SRC);
  //   };

  //   // 4. Append the new script tag to the document's head.
  //   console.log("Adding new cart script tag to head:", SCRIPT_ID);
  //   document.head.appendChild(script);

  // } else {
  //   console.log("Initial route render on client for:", location.pathname, "- script should be present from SSR.");
  //   // You could add a check here to see if the script from SSR loaded correctly
  //   // const ssrScript = document.getElementById(SCRIPT_ID);
  //   // if (!ssrScript) {
  //   //   console.warn("SSR script tag not found on initial client render!");
  //   //   // Potentially add the script here as a fallback?
  //   // }
  // }
  


};

